import { SYSTEMS_PAGES } from "constants/pages.constant.js";

import { extractSystemId } from "../../utils/utils.js";
import {
  ADD_LAYOUT_SUCCESS,
  DELETE_LAYOUT_SUCCESS,
  EDIT_LAYOUT_SUCCESS,
  RESET_LAYOUTS,
  SET_CURRENT_LAYOUT,
  SET_LAYOUTS,
  SHOW_OVERLAYLAYOUT,
  UPDATE_NEWLY_LAYOUT
} from "../actionTypes/layout";

const initialState = {
  layouts: {},
  currentLayouts: {},
  showShowOverlayLoader: false
};

const reducer = (state = initialState, action) => {
  const systemID = extractSystemId();
  if (systemID !== null) {
    switch (action.type) {
      case SET_LAYOUTS:
        return {
          ...state,
          layouts: {
            ...state.layouts,
            [systemID]: {
              ...state.layouts[systemID],
              [action.payload.type]: action.payload.layouts
            }
          }
        };
      case SET_CURRENT_LAYOUT:
        const { layout } = action.payload;
        if (layout) {
          replaceLayoutQueryParam(layout.ID);
          return {
            ...state,
            currentLayouts: {
              ...state.currentLayouts,
              [systemID]: {
                ...state.currentLayouts[systemID],
                [action.payload.type]: layout
              }
            }
          };
        } else {
          return state;
        }
      case ADD_LAYOUT_SUCCESS:
        const { type, Layout } = action.payload;
        const systemLayouts = state.layouts[systemID];
        let existingLayouts = systemLayouts ? systemLayouts[type] || [] : [];
        if (Layout.Home) {
          existingLayouts = updateHomeLayouts(Layout, existingLayouts);
        }
        const newLayouts = [Layout, ...existingLayouts];
        return {
          ...state,
          layouts: {
            ...state.layouts,
            [systemID]: {
              ...state.layouts[systemID],
              [type]: newLayouts
            }
          }
        };
      case DELETE_LAYOUT_SUCCESS:
        const page = action.payload.type;
        const currentLayoutID = state.currentLayouts[systemID][page].ID;
        const deletedLayoutID = action.payload.name;
        const updatedLayouts = state.layouts[systemID][page].filter(layout => layout.ID !== deletedLayoutID);
        const newState = JSON.parse(JSON.stringify(state));

        if (updatedLayouts.length > 0) {
          const replaceLayout = updatedLayouts[0];
          if (deletedLayoutID === currentLayoutID) {
            replaceLayoutQueryParam(replaceLayout.ID);
          }
          newState.currentLayouts[systemID][page] = replaceLayout;
          newState.layouts[systemID][page] = updatedLayouts;
          return { ...newState };
        } else {
          const emptyLayouts = { layouts: {}, currentLayouts: {} };
          return { ...emptyLayouts };
        }

      case EDIT_LAYOUT_SUCCESS:
        return editLayout(state, systemID, action);
      case UPDATE_NEWLY_LAYOUT:
        return updateNewlyAddedLayout(state, systemID, action);
      case RESET_LAYOUTS:
        return {
          layouts: {},
          currentLayouts: {}
        };
      case SHOW_OVERLAYLAYOUT:
        const { value } = action.payload;
        return {
          ...state,
          showShowOverlayLoader: value
        };
      default:
        return state;
    }
  }
};

const updateHomeLayouts = (targetLayout, sourceList) =>
  sourceList.map(layoutItem => {
    if (layoutItem.ID === targetLayout.ID) {
      layoutItem = targetLayout;
    } else if (layoutItem.UserID == targetLayout.UserID) {
      layoutItem.Home = false;
    }
    return layoutItem;
  });

const updateNewlyAddedLayout = (state, systemID, action) => {
  const { type, Layout } = action.payload;
  delete Layout.isNewlyAdded;
  const systemLayouts = state.layouts[systemID];
  const existingLayouts = systemLayouts ? systemLayouts[type] : [];
  const updateLayoutIdx = existingLayouts.findIndex(layout => layout.ID === Layout.ID);
  existingLayouts[updateLayoutIdx] = Layout;
  return {
    ...state,
    layouts: {
      ...state.layouts,
      [systemID]: { ...state.layouts[systemID], [type]: existingLayouts }
    }
  };
};

const editLayout = (state, systemID, action) => {
  const { type, Layout } = action.payload;
  delete Layout.isNewlyAdded;
  const systemLayouts = state.layouts[systemID];
  let existingLayouts = systemLayouts ? systemLayouts[type] : [];
  if (Layout.Home) {
    existingLayouts = updateHomeLayouts(Layout, existingLayouts);
  } else {
    const updateLayoutIdx = existingLayouts.findIndex(layout => layout.ID === Layout.ID);
    existingLayouts[updateLayoutIdx] = Layout;
  }
  return {
    ...state,
    currentLayouts: {
      ...state.currentLayouts,
      [systemID]: {
        ...state.currentLayouts[systemID],
        [type]: {
          ...state.currentLayouts[systemID][type],
          Name: Layout.Name,
          Home: Layout.Home
        }
      }
    },
    layouts: {
      ...state.layouts,
      [systemID]: { ...state.layouts[systemID], [type]: existingLayouts }
    }
  };
};

const replaceLayoutQueryParam = ID => {
  const pagesWithLayouts = [SYSTEMS_PAGES.DASHBOARDS, SYSTEMS_PAGES.CHARTS, SYSTEMS_PAGES.REPORTS];
  const location = window.location.href;
  const isPageWithLayout = pagesWithLayouts.some(page => location.includes(page));
  if (isPageWithLayout) {
    const queryParams = new URLSearchParams(window.location.search);
    const layout = decodeURIComponent(queryParams.get("layout"));
    if (layout === "null") {
      // "null" on first load, otherwise gets previous layout id
      window.history.replaceState(null, "", `${window.location.pathname + window.location.search}/?layout=${ID}`);
    }
    if (ID !== layout && layout !== "null" && ID !== undefined) {
      // prevents resetting current url (if layout and ID are the same, ID is the layout being switched to)
      queryParams.set("layout", ID);
      const newRelativePathQuery = `${window.location.pathname}?${queryParams.toString()}`;
      window.history.pushState(null, "", newRelativePathQuery);
    }
  }
};

const deleteLayoutQueryParam = () => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.delete("layout");
};

export default reducer;
